import { Map as ImmutableMap } from 'immutable';
import { createAction } from 'redux-actions';
import { createDialog } from 'data/rootUi/actions';
import { mkRootUiData } from 'data/rootUi/types';
import { DIALOG_TYPE as DIALOG_TYPE_WF_BILLS_SCOUT } from './types';

export const doWFBillsScout = createAction(
  createDialog,
  () => mkRootUiData({
    type: DIALOG_TYPE_WF_BILLS_SCOUT,
    allowNesting: false,
  })
);

export const doWFBillsScoutBillIncomeFlow = createAction(
  createDialog,
  (payload) => mkRootUiData({
    type: DIALOG_TYPE_WF_BILLS_SCOUT,
    allowNesting: false,
    props: ImmutableMap({
      ...payload,
      billsIncomeFlow: true,
    }),
  })
);